import axios from 'axios';

const SystemService = {
  fetchLicenseStatus() {
    return axios.get('/system/license-status').then((res) => res.data);
  },
  fetchAdminLicenseStatus() {
    return axios.get('/system/license-status/admin').then((res) => res.data);
  },
  activate(payload) {
    return axios.post('/system/activate', payload).then((res) => res.data);
  },
  syncLicense(payload) {
    return axios.put('/system/license', payload).then((res) => res.data);
  },
  registerLicense(payload) {
    return axios.post('/system/license/register', payload).then((res) => res.data);
  },
  fetchOnboardingStatus() {
    return axios.get('/system/onboarding-status').then((res) => res.data);
  },
  completeOnboarding(payload) {
    return axios.post('/system/onboard', payload).then((res) => res.data);
  },
};

export default SystemService;
